// Varianta corectă și curată (modernă, profesională)
// Semnul ! înseamnă în TypeScript știu sigur că această variabilă nu e null sau undefined
export const API = process.env.REACT_APP_API_URL!;

// export const API =  process.env.NODE_ENV === "production"
//     ? "https://hotelvpf-api-svc.onrender.com"
//     : "https://localhost:7191";

export async function api<T = any>(
  path: string,
  opts: RequestInit = {}
): Promise<T> {
  const token = localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(opts.headers || {}),
  };

  const res = await fetch(`${API}${path}`, { ...opts, headers });
  const text = await res.text(); // întotdeauna există pe Response

  // ✅ încercăm să convertim JSON, dacă nu merge trimitem fallback
  try {
    const data = JSON.parse(text);
    return { ...data, ok: res.ok } as unknown as T;
  } catch {
    return { message: text, ok: res.ok } as unknown as T;
  }
}
